module.exports = __webpack_public_path__ + "static/media/ma.eef6b831.webp";